module.exports = "<p>\n  permission works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/permissions/permission/permission.component.html
// module id = ../../../../../src/app/dashboard/pages/permissions/permission/permission.component.html
// module chunks = main